var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticStyle:{"white-space":"nowrap"}},[(_vm.$props.value)?[_vm._v(" "+_vm._s(_vm._f("pretty_numeric")(_vm.$props.value))+" ")]:[_vm._v("0 ")],_c('i',{staticClass:"fal fa-percent"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }